{
  "optionalTranslationKeyNotSet": "Optionaler Übersetzungs-Schlüssel nicht gesetzt",
  "aboutme": {
    "hello": "Hallo",
    "iam": "Ich bin",
    "title": "ITler, DJ & Producer aus Berlin",
    "description": "{age} Jahre, Berliner, und irgendwo zwischen Code und Beats zu Hause. Tagsüber studiere ich Informatik an der TU Berlin, nachts produziere ich Tracks oder bastle an meinen Projekten. Mein Praktikum bei der KfW hat mir gezeigt, dass ich auch im IT-Betrieb gut klarkomme – aber mein Herz schlägt für die Entwicklung. Ob Software bauen oder Musik machen Hauptsache kreativ.",
    "myPlaylist": "Meine Playlist",
    "myCurrentSong": "Mein aktuellster Song"
  },
  "aiLabel": {
    "title": "KI-Transparenzhinweis",
    "description": "Teile dieser Website wurden mit Unterstützung von Künstlicher Intelligenz (KI) entwickelt. Die KI kam bei der Übersetzung (Internationalisierung), der Design-Implementierung sowie zur sprachlichen Feinabstimmung zum Einsatz. Alle inhaltlichen Informationen und Fakten sind jedoch zu 100 % authentisch, von Menschen geprüft und wurden durch die KI weder verfälscht noch eigenständig generiert.",
    "readMore": "Mehr zur EU-KI-Kennzeichnung erfahren",
    "link": "https://digital-strategy.ec.europa.eu/de/policies/eu-icons-labelling-ai-generated-content"
  },
  "commandMenu": {
    "searchPlaceholder": "Befehl eingeben oder suchen...",
    "noResults": "Keine Ergebnisse gefunden.",
    "languages": "Sprachen",
    "settings": "Einstellungen",
    "misc": "Sonstiges",
    "cookieSettings": "Cookie-Einstellungen",
    "commandPalette": "Befehlspalette",
    "commandPaletteDescription": "Einen Befehl zum Ausführen suchen"
  },
  "common": {
    "loading": "Laden...",
    "error": "Fehler",
    "success": "Erfolg",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "view": "Ansehen",
    "submit": "Absenden",
    "close": "Schließen"
  },
  "contact": {
    "description": "Lass uns in Kontakt treten! Buche ein Meeting.",
    "bookMeeting": "Meeting buchen",
    "calDescription": "Plane ein Gespräch oder Meeting über Cal.com",
    "mobilephone": "Mobiltelefon",
    "address": "Adresse"
  },
  "cookieConsent": {
    "title": "Cookie-Hinweis",
    "description": "Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu bieten. Es werden keinerlei analytische Daten über Sie oder Ihr Gerät erhoben. Standardmäßig werden nur technisch notwendige Cookies gesetzt. Inhalte von Drittanbietern können auf Wunsch blockiert werden. Ihre Cookie-Einstellungen werden für 7 Tage gespeichert.",
    "technicalCookies": {
      "title": "Technische Cookies",
      "description": "Diese Cookies sind für grundlegende Website-Funktionen erforderlich, wie das Speichern Ihrer Einstellungen und Sprachpräferenzen. Sie können nicht deaktiviert werden. Es werden keine persönlichen oder analytischen Daten erhoben."
    },
    "thirdPartyCookies": {
      "title": "Inhalte von Drittanbietern",
      "description": "Einige Seiten enthalten eingebettete Inhalte von Drittanbietern wie Cal.com oder Apple Music. Diese Dienste können eigene Cookies setzen, die außerhalb meiner Kontrolle liegen. Sie können diese Inhalte jederzeit über Ihre Cookie-Einstellungen blockieren."
    },
    "acceptAll": "Alle akzeptieren",
    "rejectAll": "Alle ablehnen",
    "managePreferences": "Einstellungen verwalten",
    "savePreferences": "Einstellungen speichern",
    "moreInfo": "Mehr Informationen",
    "cookieSettings": "Cookie-Einstellungen",
    "language": "Sprache",
    "categories": {
      "multimedia": {
        "description": "Erforderlich für eingebettete Medien wie Apple Music und Songlink Player."
      },
      "socialMedia": {
        "description": "Erforderlich für eingebettete Social-Media-Inhalte."
      },
      "contact": {
        "title": "Kontakt & Buchung",
        "description": "Erforderlich für den Cal.com Buchungskalender."
      },
      "tracking": {
        "title": "Analytik & Tracking",
        "description": "Ermöglicht die Analyse des Website-Verkehrs zur Verbesserung der Benutzererfahrung."
      }
    },
    "blockedContent": {
      "title": "Inhalt blockiert",
      "description": "Dieser Inhalt ist blockiert, da Sie die entsprechenden Cookies nicht akzeptiert haben. Aktivieren Sie die entsprechende Kategorie: ({category}) in Ihren Cookie-Einstellungen, um diesen Inhalt anzuzeigen.",
      "button": "Cookie-Einstellungen"
    }
  },
  "cv": {
    "recommendation": {
      "printingSettings": {
        "title": "Beste Druckeinstellungen",
        "description": "Skalierung 62 %, Ränder: Standard, Hintergrundgrafiken ein"
      },
      "printingNotice": {
        "title": "Empfehlung für den Druck",
        "description": "Nutzen Sie den PDF-Button oberen rechts, um den Lebenslauf optimal zu drucken."
      }
    },
    "about": {
      "title": "Staatlich geprüfter IT-Assistent | Softwareentwickler",
      "email": "E-Mail",
      "telnum": "Telefon",
      "address": {
        "germany": "Deutschland"
      },
      "birthday": "Geburtsdatum"
    },
    "education": {
      "title": "Bildungsweg",
      "items": {
        "tuberlin": {
          "name": "Technische Universität Berlin",
          "imgAlt": "Logo der Technischen Universität Berlin",
          "description": "Informatik-Studium (B.Sc.) – Schwerpunkte: Algorithmen, Datenstrukturen, Softwareentwicklung",
          "badges": ["Berlin", "Bachelor of Science", "Informatik"]
        },
        "lookingForApprenticeship": {
          "name": "Überbrückungsjahr",
          "imgAlt": "Aktiv auf Stellensuche",
          "description": "Ich habe in dieser Zeit aktiv nach einem Ausbildungsplatz als Fachinformatiker für Anwendungsentwicklung oder ein Duales Studiium im Bereich Informatik gesucht und meine persönlichen Programmierprojekte weitergeführt."
        },
        "oszimt": {
          "name": "OSZ Informations- und Medizintechnik Berlin",
          "imgAlt": "Logo des OSZ IMT Berlin",
          "description": "Doppelqualifizierende Berufsausbildung: Staatlich geprüfter IT-Assistent mit Fachhochschulreife. Schwerpunkte: Softwareentwicklung (Java), Netzwerktechnik (Cisco), Datenbanken (MySQL)",
          "badges": [
            "Berlin",
            "Berufsausbildung",
            "Fachhochschulreife",
            "Informatik"
          ]
        },
        "cvl": {
          "name": "Carl-von-Linné-Schule Berlin",
          "imgAlt": "Logo der Carl-von-Linné-Schule",
          "description": "Mittlerer Schulabschluss (MSA) mit Berechtigung zum Übergang in die gymnasiale Oberstufe",
          "badges": ["Berlin", "MSA (OG)"]
        }
      }
    },
    "experience": {
      "title": "Berufserfahrung",
      "items": {
        "kfw": {
          "name": "KfW Bankengruppe – IT-Abteilung",
          "imgAlt": "Logo der KfW Bankengruppe",
          "description": "• Entwickelte und implementierte Automatisierungsskripte mit Ansible zur Optimierung von IT-Prozessen\n• Erstellte technische Dokumentation in Confluence für nachhaltige Wissenssicherung\n• Arbeitete im Team zur Verbesserung der IT-Infrastruktur",
          "badges": [
            "Berlin",
            "IT-Praktikum",
            "Ansible",
            "Automatisierung",
            "Confluence"
          ]
        },
        "adk": {
          "name": "Akademie der Künste Berlin",
          "imgAlt": "Logo der Akademie der Künste",
          "description": "• Unterstützte bei der Entwicklung digitaler Synthesizer-Software\n• Sammelte Erfahrung an der Schnittstelle von Technologie und Kreativität",
          "badges": [
            "Berlin",
            "Softwareentwicklung",
            "Musik",
            "Schülerpraktikum"
          ]
        },
        "tosa": {
          "name": "Tosa Security & Service GmbH & Co KG",
          "imgAlt": "Logo der Tosa Security & Service GmbH",
          "description": "• Übernahm administrative Aufgaben und Büroorganisation\n• Erlernte Grundlagen der Unternehmensabläufe",
          "badges": ["Trebbin", "Büroorganisation", "Schülerpraktikum"]
        },
        "pfennig": {
          "name": "Pfennigpfeiffer Handels GmbH",
          "imgAlt": "Logo von Pfennigpfeiffer",
          "description": "• Erste Berufserfahrung im Einzelhandel: Warenpräsentation und Kundenservice",
          "badges": ["Berlin", "Einzelhandel", "Schülerpraktikum"]
        }
      }
    },
    "skills": {
      "title": "Kenntnisse & Fähigkeiten",
      "badges": {
        "development": "Softwareentwicklung",
        "configuration": "Systemkonfiguration",
        "operatingSystem": "Betriebssystem",
        "frontend": "Frontend-Entwicklung",
        "automation": "IT-Automatisierung",
        "office": "Office-Anwendungen",
        "textEditor": "Text-Editor",
        "multifunctional": "Multifunktional",
        "retail": "Einzelhandel",
        "language": "Sprache",
        "native": "Muttersprache"
      },
      "categories": {
        "languages": {
          "title": "Sprachen"
        },
        "programming": {
          "title": "Programmiersprachen"
        },
        "databases": {
          "title": "Datenbanken"
        },
        "automation": {
          "title": "Automatisierung & DevOps"
        },
        "operatingSystems": {
          "title": "Betriebssysteme"
        },
        "networking": {
          "title": "Netzwerk"
        },
        "devEnvironments": {
          "title": "Entwicklungsumgebungen"
        },
        "office": {
          "title": "Office & Kollaboration"
        }
      }
    },
    "durationKeys": {
      "years": "{count} Jahre",
      "year": "{count} Jahr",
      "semesters": "{count} Semester",
      "semester": "{count} Semester",
      "quarters": "{count} Quartale",
      "quarter": "{count} Quartal",
      "months": "{count} Monate",
      "month": "{count} Monat",
      "weeks": "{count} Wochen",
      "week": "{count} Woche",
      "days": "{count} Tage",
      "day": "{count} Tag"
    }
  },
  "footer": {
    "connect": "Verbinden",
    "legal": "Rechtliches",
    "rights": "Alle Rechte vorbehalten."
  },
  "imprint": {
    "title": "Impressum",
    "tmg": {
      "title": "Angaben gemäß § 5 TMG",
      "germany": "Deutschland"
    },
    "contact": {
      "title": "Kontakt"
    },
    "rstv": {
      "title": "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV"
    },
    "cookies": {
      "title": "Cookie-Richtlinie",
      "description": "Diese Website verwendet Cookies, um das bestmögliche Erlebnis zu bieten. Es werden keinerlei analytische Daten über Sie oder Ihr Gerät erhoben. Nachfolgend finden Sie detaillierte Informationen zu den auf dieser Website verwendeten Cookies.",
      "technical": {
        "title": "Technische Cookies",
        "description": "Wir verwenden nur technisch notwendige Cookies, die für die Funktion der Website unerlässlich sind. Dazu gehören Cookies zum Speichern Ihrer Sprachpräferenz und des Cookie-Zustimmungsstatus. Diese Cookies können nicht deaktiviert werden."
      },
      "thirdParty": {
        "title": "Inhalte von Drittanbietern (Blockierbar)",
        "description": "Einige Seiten enthalten eingebettete Inhalte von Drittanbietern. Diese Dienste können eigene Cookies setzen, die außerhalb meiner Kontrolle liegen. Sie können diese Inhalte jederzeit über Ihre Cookie-Einstellungen blockieren."
      },
      "storage": {
        "title": "Speicherung der Einstellungen",
        "description": "Ihre Cookie-Einstellungen werden lokal in einem Cookie für 7 Tage gespeichert. Danach werden Sie erneut gefragt. Sie können Ihre Einstellungen jederzeit ändern, indem Sie den Button Cookie-Einstellungen unten oder im Footer klicken."
      }
    }
  },
  "layout": {
    "title": "Fabian Aps Portfolio/Impressum",
    "description": "meine eigene Portfolio/Impressum Webseite"
  },
  "linkhub": {
    "description": "Ob Code, Beats oder Random Content – hier findest du mich überall.",
    "sections": {
      "socialMedia": {
        "description": "Die Plattformen, auf denen ich aktiv bin.",
        "instagram": {
          "description": "Storys aus dem Alltag, Events und der ganze Rest."
        },
        "tiktok": {
          "description": "Wenn ich mal was Kreatives in unter einer Minute zeigen will."
        },
        "threads": {
          "description": "Meine Gedanken, wenn Instagram nicht reicht."
        },
        "bsky": {
          "description": "Für alle, die Twitter-Alternative suchen."
        },
        "twitter": {
          "description": "Tech-Diskussionen und der gelegentliche Rant."
        },
        "discord": {
          "description": "Hier kann man mich direkt erreichen – oder einfach chillen."
        },
        "youtube": {
          "description": "Tutorials, Musik-Releases und was mir sonst einfällt."
        }
      },
      "websites": {
        "description": "Projekte, die im Web leben.",
        "myWebsite": {
          "title": "Diese Website",
          "description": "Du bist schon hier – aber schau dich ruhig weiter um."
        },
        "cbps": {
          "headding": "Die Crew-Seite",
          "description": "Die Website meiner Freundesgruppe – chaotisch, aber mit Liebe gemacht."
        },
        "blogCBPS": {
          "headding": "News & Stories",
          "description": "Updates aus dem Leben der Crew."
        }
      },
      "other": {
        "title": "Mehr von mir",
        "description": "Was nicht in die anderen Kategorien passt.",
        "gitlab": {
          "description": "Hier lebt mein Code – Open Source und persönliche Projekte. Mein neues Zuhause für Code."
        },
        "github": {
          "description": "Hier lebt mein Code – Open Source und persönliche Projekte. Mein altes Zuhause für Code."
        },
        "playlist": {
          "title": "Meine Playlist",
          "headding": "Was ich so höre",
          "description": "Von Techno bis Indie – mein aktueller Soundtrack."
        },
        "song": {
          "title": "Mein Song",
          "description": "Mein neuester Track – hör mal rein!"
        }
      }
    }
  },
  "projects": {
    "pinned": "Gepinnte Projekte",
    "title": "Projekte",
    "all": "Alle Projekte",
    "projectCount": "{count} Projekte",
    "searchPlaceholder": "Projekte durchsuchen…",
    "showingResultsFor": "Ergebnisse für \"{query}\"",
    "noResults": "Keine Projekte gefunden.",
    "clearSearch": "Suche zurücksetzen",
    "items": {
      "portfolio": {
        "title": "Dieses Portfolio",
        "description": "Die Seite, auf der du gerade bist. Next.js, TypeScript, und viel zu viele Nächte mit CSS.",
        "imgAlt": "Portfolio Screenshot"
      },
      "simplesql": {
        "description": "Wenn du SQL-Statements ausführen willst, ohne erst eine halbe Stunde IDE aufzusetzen. TUI für schnelle Queries.",
        "imgAlt": "simplesql Terminal Interface"
      },
      "localServices": {
        "title": "Mein Self-Hosted Stack",
        "description": "SearxNG, Nextcloud und was man sonst so braucht, wenn man Google nicht alles erzählen will.",
        "imgAlt": "SearxNG Logo"
      },
      "schulRepo": {
        "title": "Schul-Repository",
        "description": "Drei Jahre OSZ IMT in Code – von den ersten Java-Gehversuchen bis zu echten Projekten.",
        "imgAlt": "OSZ IMT Logo"
      },
      "klassenWebsite": {
        "description": "Die offizielle Klassenwebsite. Gebaut mit der Crew, gehostet mit Stolz.",
        "imgAlt": "OSZ IMT Logo"
      },
      "klassenApp": {
        "description": "Vertretungsplan, Notenrechner, Klassenchat – alles was wir im Schulalltag gebraucht haben.",
        "imgAlt": "Klassen App Icon"
      },
      "simpleSqlRunner": {
        "description": "Die GUI-Version von simplesql. Für alle, die lieber klicken als tippen.",
        "imgAlt": "Simple SQL Runner Screenshot"
      },
      "dotfilesMacos": {
        "description": "Mein komplettes Mac-Setup in einem Repo. Zsh, Neovim, Homebrew – alles dabei.",
        "imgAlt": "Terminal mit Dotfiles"
      },
      "nixConfig": {
        "description": "Reproduzierbares System-Setup. Einmal konfigurieren, überall deployen.",
        "imgAlt": "NixOS Logo"
      },
      "dotfilesLinux": {
        "description": "Gleiche Philosophie, anderes OS. Hyprland, Waybar und der ganze Wayland-Stack.",
        "imgAlt": "Linux Desktop Screenshot"
      },
      "cbpsWebsite": {
        "description": "Die digitale Heimat meiner Freundesgruppe. Chaotisch, bunt und absolut wir.",
        "imgAlt": "comboom.sucht Logo"
      },
      "cbpsApp": {
        "description": "Private Events planen, Memes teilen, Insider-Jokes sammeln – die Crew-App.",
        "imgAlt": "comboom.sucht App Icon"
      },
      "uniRepo": {
        "title": "TU Berlin Repository",
        "description": "Algorithmen, Datenstrukturen, und der Beweis dass ich doch noch Mathe kann.",
        "imgAlt": "TU Berlin Logo"
      },
      "liveWallpaper": {
        "title": "Interaktives Live Wallpaper",
        "description": "Partikel im Nord-Theme, C++23 unter der Haube, läuft native und im Browser. Mein Spielplatz für Shader-Experimente.",
        "imgAlt": "Live Wallpaper Preview"
      }
    }
  },
  "recommendation": {
    "projects": {
      "title": "Von der Idee zum Code",
      "description": "Schau dir an, was passiert wenn ich nachts nicht schlafen kann.",
      "action": {
        "label": "Projekte entdecken"
      }
    },
    "aboutme": {
      "title": "Der Mensch hinter dem Code",
      "description": "IT-Nerd bei Tag, DJ bei Nacht – lern mich kennen.",
      "action": {
        "label": "Mehr erfahren"
      }
    },
    "cv": {
      "title": "Vom OSZ zur TU Berlin",
      "description": "Mein Weg durch die IT-Welt – mit allen Stationen.",
      "action": {
        "label": "Lebenslauf ansehen"
      }
    },
    "linkhub": {
      "title": "Überall zu finden",
      "description": "Von Instagram bis GitHub – hier bin ich unterwegs.",
      "action": {
        "label": "Alle Profile"
      }
    },
    "gitlab": {
      "title": "Wo der Code lebt",
      "description": "@mcpeaps_HD – Open Source aus Leidenschaft. Mein neues Zuhause für Code.",
      "action": {
        "label": "Auf GitLab"
      }
    },
    "github": {
      "title": "Wo der Code lebt",
      "description": "@mcpeapsUnterstrichHD – Open Source aus Leidenschaft. Mein altes Zuhause für Code.",
      "action": {
        "label": "Auf GitHub"
      }
    },
    "twitter": {
      "title": "Meine ungefilterten Gedanken",
      "description": "@mcpeaps_HD – Tech-Talks und Random Thoughts.",
      "action": {
        "label": "Auf X"
      }
    },
    "instagram": {
      "title": "Zwischen Code und Beats",
      "description": "@mcpeaps_hd – Mein Alltag in Bildern.",
      "action": {
        "label": "Auf Instagram"
      }
    },
    "tiktok": {
      "title": "Wenn's mal schnell gehen muss",
      "description": "@mcpeaps_hd – Content in 60 Sekunden.",
      "action": {
        "label": "Auf TikTok"
      }
    },
    "threads": {
      "title": "Mehr als 280 Zeichen",
      "description": "@mcpeaps_hd – Wenn ein Tweet nicht reicht.",
      "action": {
        "label": "Auf Threads"
      }
    },
    "bluesky": {
      "title": "Das neue Social Media",
      "description": "@mcpeapsunterstrichhd.dev – Dezentral und frei.",
      "action": {
        "label": "Auf Bluesky"
      }
    }
  },
  "sidebar": {
    "toggleSidebar": "Seitenleiste umschalten",
    "noLanguageFound": "Keine Sprache gefunden.",
    "searchLanguage": "Sprache suchen..."
  },
  "sites": {
    "root": "Startseite",
    "imprint": "Impressum",
    "aboutme": "Über mich",
    "projects": "Projekte",
    "contact": "Kontaktier mich",
    "cv": "Lebenslauf",
    "linkhub": "Linkübersicht",
    "notFound": "404 - Seite nicht gefunden"
  },
  "reloadPrompt": {
    "message": "Eine neue Version ist verfügbar. Bitte aktualisiere die Seite.",
    "refresh": "Aktualisieren"
  }
}
